import { type ReactNode } from "react";
import { Icon } from "#app/components/ui/icon.tsx";

const styles = {
	info: {
		border: "border-l-blue-600 dark:border-l-blue-400",
		bg: "bg-blue-50/50 dark:bg-blue-950/20",
		icon: "info" as const,
		iconColor: "text-blue-600 dark:text-blue-400",
	},
	warning: {
		border: "border-l-amber-500 dark:border-l-amber-400",
		bg: "bg-amber-50/50 dark:bg-amber-950/20",
		icon: "circle-alert" as const,
		iconColor: "text-amber-500 dark:text-amber-400",
	},
	tip: {
		border: "border-l-green-600 dark:border-l-green-500",
		bg: "bg-green-50/50 dark:bg-green-950/20",
		icon: "lightbulb" as const,
		iconColor: "text-green-600 dark:text-green-500",
	},
};

interface CalloutProps {
	type?: "info" | "warning" | "tip";
	children: ReactNode;
}

export function Callout({ type = "info", children }: CalloutProps) {
	const s = styles[type];
	return (
		<aside
			className={`my-6 rounded-r-lg border-l-4 ${s.border} ${s.bg} p-4`}
		>
			<div className="flex gap-3">
				<Icon
					name={s.icon}
					className={`mt-0.5 size-5 shrink-0 ${s.iconColor}`}
				/>
				<div className="text-body-sm text-foreground [&>p]:mb-0">
					{children}
				</div>
			</div>
		</aside>
	);
}
